import { CAlert, CButton, CCol, CContainer, CForm, CFormGroup, CInput, CLabel, CRow } from '@coreui/react';
import React from 'react';
import { Redirect } from 'react-router';
import { ILoginViewModel } from '../abstraction/';
import { KLangPanel, KLoadingPanel, NavMenu } from '../components';
import { AppLabels } from '../core/AppLabels';
import { Utils } from '../core/utils';
import { dispatcher, Karma, securitySvc } from '../Karma';

interface IProps {
	children?: React.ReactNode;
}

interface IState {
	login: string,
	password: string,
	error: string,
	loading: boolean;

	model: ILoginViewModel;
}

export class LoginView extends React.Component<IProps, IState> {
	static URL: string = "/login";

	constructor(props) {
		super(props);
		this.state = {
			login: "",
			password: "",
			error: "",
			loading: true,

			model: {
				buttonLabel: "Login",
				loginLabel: "User",
				passwordLabel: "Password",
				titleLabel: "Please log in",

				error: "",
				folder: "Unknown",
				version: "Unknown",

				showFolder: false,
				showVersion: false,

			}
		}

		this.loadResources();

		Karma.OnCultureChanged.add((culture) => {
			this.loadResources();
		});


	}

	//#region React Hacks

	componentDidMount = () => {
		window.onkeypress = (ev) => { this.onKeyPress(ev); };
	}

	componentWillUnmount = () => {
		clearTimeout(this.timeOutHdlr);
		window.onkeypress = (ev) => { };
	}

	//#endregion
	//#region Méthodes diverses
	private loadResources = () => {
		dispatcher.getLoginRessources(Karma.getCurrentCultureCode())
			.then((result) => {
				if (result != null) this.setState({ model: result });
				this.setState({ loading: false });
				this.forceUpdate()
			})
			.catch((err) => {
				this.setState({ loading: false });
			});
	}
	//#endregion

	//#region View events

	//#region Mini Lecteur code barre spécifique login
	private scanInProgress: boolean = false;
	private barcode: string = "";
	private timeOutHdlr: any;

	onKeyPress = (ev: any) => {
		try {
			this.barcode = this.barcode + ev.key;

			// Tant qu'on n'est pas sur un ': ', inutile de chercher AUTH: => gain de perf
			if (ev.key == ":") {
				if (this.barcode.indexOf("AUTH:") != -1) {
					this.scanInProgress = true;
					this.barcode = "";

					// On définit un time out
					// si on a pas quitté le mode réception au bout de 2000ms, on réinitialise
					clearTimeout(this.timeOutHdlr);
					this.timeOutHdlr = setTimeout(() => {
						this.barcode = "";
						this.scanInProgress = false;
					}, 3000);

				}
			}
			if (this.scanInProgress) {
				// Gain de temps. ON ne cherche :AUTH que si nécessaire
				if (ev.key == "H") {
					if (this.barcode.indexOf(":AUTH") != -1) {
						this.barcode = this.barcode.split(":AUTH")[0];
						this.scanInProgress = false;
						let logs = Utils.hexToString(atob(this.barcode));
						let username = logs.split(":")[0].toLocaleUpperCase();
						this.login(username, logs.split(":")[1])
					}
				}
			}
		}
		catch (err) {
			this.barcode = "";
			this.scanInProgress = false;
			clearTimeout(this.timeOutHdlr);
		}
	}

	//#endregion 

	private async login(username: string, password: string) {
		securitySvc.Login(username, password)
			.then(
				async (data) => {
					if (data.lockedRecords == 1) {
						var result = await dispatcher.ConfirmBox(AppLabels.locksDetected, AppLabels.locksDetectedConfirm, AppLabels.yes, AppLabels.no, 0);
						if (result) {
							await dispatcher.Logout(true);
						}
					}

					this.setState({ password: "", error: "" });
					Karma.OnRefresh.trigger(null);
				},
				(error) => {
					this.setState({ error: AppLabels.authenticateError });
				})
	}

	onSubmitClick = (event) => {
		event.preventDefault();
		if (this.state.login.length === 0) { return; }
		if (this.state.password.length === 0) { return; }

		let username = this.state.login.toLocaleUpperCase();
		this.login(username, this.state.password)
	}

	onLoginChange = (event) => {
		this.setState({ login: event.target.value, });
	}

	onPasswordChange = (event) => {
		this.setState({ password: event.target.value, });
	}

	onFlagClick = (lang: string) => {
		Karma.setLang(lang);
		this.forceUpdate();
	}

	//#endregion

	//#region Rendering

	renderVersion = () => {
		if (this.state.model == null) return;
		if (this.state.model.showVersion == false) return;
		let version = this.state.model.version;

		return (<div className="footer left">
			<CLabel>V{version}</CLabel>
		</div>);
	}

	renderFolder = () => {
		if (this.state.model == null) return;
		if (this.state.model.showFolder == false) return;
		let folder = this.state.model.folder;

		return (<div className="footer right">
			<CLabel>X3: {folder}</CLabel>
		</div>);
	}

	render() {
		if (securitySvc.isAuth()) { return (<Redirect to="/"></Redirect>); }
		if (this.state.loading) return <KLoadingPanel></KLoadingPanel>
		let error = (this.state.error != "") ? <CAlert color="danger" closeButton>{this.state.error}</CAlert> : ""

		let version = this.renderVersion();
		let folder = this.renderFolder();

		return (
			<div>
				<NavMenu securityService={securitySvc} userFullName="" />
				<div className="Login">
					<CContainer >
						{error}
						<CRow>
							<CCol xs="6" >
								<h1><CLabel>{this.state.model.titleLabel}</CLabel> </h1>
							</CCol>
							<CCol xs="6" >
								<KLangPanel cultureProvider={Karma} onLangChanged={this.onFlagClick}></KLangPanel>
							</CCol>
						</CRow>

						<CForm>
							<CFormGroup >
								<CLabel>{this.state.model.loginLabel}</CLabel>
								<CInput name="login" placeholder={this.state.model.loginLabel} value={this.state.login} onChange={this.onLoginChange} />
							</CFormGroup>

							<CFormGroup >
								<CLabel>{this.state.model.passwordLabel}</CLabel>
								<CInput type="password" name="password" id="password" placeholder={this.state.model.passwordLabel} value={this.state.password} onChange={this.onPasswordChange} />
							</CFormGroup>

							<CButton color="secondary" type="submit" onClick={this.onSubmitClick} block>{this.state.model.buttonLabel}</CButton>

						</CForm>
						<hr />
						<CRow>
							<CCol xs="6" >
								{version}
							</CCol>
							<CCol xs="6" >
								{folder}
							</CCol>
						</CRow>


					</CContainer>
				</div>
			</div>
		)
	}

	//#endregion
}